import { BaseGenerator } from '../core/BaseGenerator.js';
import { ChecksumCalculator } from '../utils/ChecksumCalculator.js';

/**
 * Dutch BSN generator following Single Responsibility Principle
 */
export class BsnGenerator extends BaseGenerator {
  generate() {
    let bsn;
    do {
      // Generate 9 random digits
      bsn = this.randomDigits(9);
      // Ensure first digit is not 0
      if (bsn[0] === '0') {
        bsn = this.randomInt(1, 9) + bsn.substring(1);
      }
    } while (!ChecksumCalculator.calculateBsnChecksum(bsn));

    return bsn;
  }
}